import 'moment/dist/locale/ru'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import 'normalize.css'
import 'rc-dropdown/assets/index.css'
import 'rc-pagination/assets/index.css'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-day-picker/style.css'
import 'react-image-gallery/styles/css/image-gallery.css'
import 'scss/common.scss'

const bootstrap = async () => {
	if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'true') {
		const { prepareMockMode } = await import('client/mockMode')
		prepareMockMode()
	}
	const { Root } = await import('client/Root')
	const container = document.getElementById('root')
	const root = createRoot(container!)
	const isStrictMode = new URLSearchParams(window.location.search).get('strict') !== '0'

	root.render(
		isStrictMode ? (
			<StrictMode>
				<Root />
			</StrictMode>
		) : (
			<Root />
		)
	)
}

bootstrap().catch(console.error)
